import {CoordinateModel, DEFAULT_COORDINATE} from "@/shared/model/CoordinateModel";
import * as z from "zod";

const schema = z.object({
	id: z.string(),
	affiliation: z.string().nullable(),
	corporationName: z.string().nullable(),
	telephone: z.string().nullable(),
	fax: z.string().nullable(),
	address: z.string().nullable(),
	coordinate: CoordinateModel.model
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxCorporationSimpleResModel = {schema, model};
export type ITaxCorporationSimpleResModel = z.infer<typeof TaxCorporationSimpleResModel.model>;

export const DEFAULT_TAX_CORPORATION_SIMPLE_RES: ITaxCorporationSimpleResModel = {
	id: "",
	affiliation: "",
	corporationName: "",
	telephone: "",
	fax: "",
	address: "",
	coordinate: DEFAULT_COORDINATE
};
